import { command, put, query } from "@/api";
import type { FormAnswer } from "@/forms/contract";
import { ActionProgressSchema, OnboardingCommandSchema, OnboardingSchema } from "./contract";
export const onboardingKey = (
  organizationId: string | null | undefined,
  userId: string | undefined,
) => ["onboarding", organizationId, userId] as const;
export const getOnboarding = () => query("/v1/onboarding", OnboardingSchema);
export const startOnboarding = (key: string) =>
  command("/v1/onboarding/start", {}, OnboardingCommandSchema, key);
export const skipOnboarding = (key: string) =>
  command("/v1/onboarding/skip", {}, OnboardingSchema, key);
export const saveOnboarding = (input: { revision: number; answers: FormAnswer[]; key: string }) =>
  put(
    "/v1/onboarding/answers",
    { revision: input.revision, answers: input.answers },
    OnboardingCommandSchema,
    input.key,
  );
export const completeOnboarding = (input: { revision: number; key: string }) =>
  command(
    "/v1/onboarding/complete",
    { revision: input.revision },
    OnboardingCommandSchema,
    input.key,
  );
export const retryOnboarding = (key: string) =>
  command("/v1/onboarding/retry", {}, OnboardingCommandSchema, key);

// Executado pela guarda antes de montar o shell, inclusive em URLs diretas.
export async function loadOnboardingRequirement(
  identity: { role: string | null; tenantId: string | null; actorId: string },
  client: import("@tanstack/react-query").QueryClient,
  viewAs: string | null,
) {
  if (identity.role !== "mentorado" || !identity.tenantId || viewAs) return false;
  const state = await client.fetchQuery({
    queryKey: onboardingKey(identity.tenantId, identity.actorId),
    queryFn: getOnboarding,
    staleTime: 10_000,
    retry: false,
  });
  return state.required;
}

export const updateOnboardingAction = (input: {
  actionIndex: number;
  completed: boolean;
  key: string;
}) =>
  put(
    "/v1/onboarding/actions",
    { actionIndex: input.actionIndex, completed: input.completed },
    ActionProgressSchema,
    input.key,
  );
